import { CaptchaConfig } from '../components/templates/Form/Container/types'

declare global {
  interface Window {
    grecaptcha?: {
      enterprise?: {
        execute: (
          siteKey: string,
          options: { action: string }
        ) => Promise<string>
      }
    }
  }
}

let isCaptchaScriptLoaded = false

export function loadCaptchaScript(siteKey: string) {
  if (isCaptchaScriptLoaded) {
    return
  }

  const script = document.createElement('script')
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}&badge=bottomleft`
  script.async = true
  script.defer = true
  script.id = 'g-recaptcha-script'
  document.body.appendChild(script)

  isCaptchaScriptLoaded = true
}

export async function getRecaptchaToken(
  captcha?: CaptchaConfig
): Promise<string | null> {
  const isEnabled = Boolean(captcha?.config?.enabled)
  if (!isEnabled) {
    return null
  }

  const siteKey = captcha?.config?.siteKey
  const action = captcha?.config?.action
  if (!siteKey || !action) {
    return null
  }

  const enterprise = window?.grecaptcha?.enterprise
  if (!enterprise?.execute) {
    return null
  }

  try {
    return await enterprise.execute(siteKey, { action })
  } catch (err) {
    return null
  }
}
